import React from 'react';
import { PROPERTY_IMAGES_URL, AGENCY_LOGOS_URL } from "../../../../constants/url";

const TemplateLuxury = ({ property, images, currentagency }) => {
  const imagesArr = images?.slice(0, 5).map((img) => `${PROPERTY_IMAGES_URL}${img.propertyimages}`) || [];
  
  const formatPrice = (num) => {
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Crore`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} Lakh`;
    return num?.toLocaleString() || "0";
  };

  return (
    <div style={{ width: '1080px', height: '1920px', backgroundColor: '#0a0a0a', position: 'relative', overflow: 'hidden', margin: 0, padding: 0, display: 'flex', flexDirection: 'column' }}>
      {/* Background Cinematic Image with Overlay */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <img 
          src={imagesArr[0]} 
          crossOrigin="anonymous"
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }}
          alt="background"
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 40%, rgba(0,0,0,0.9) 100%)' }} />
      </div>

      {/* Side Branding */}
      <div style={{ position: 'absolute', right: '40px', top: '50%', transform: 'rotate(90deg) translateY(-50%)', transformOrigin: 'right center', zIndex: 20 }}>
        <p style={{ color: 'rgba(243, 188, 7)', fontSize: '26px', fontWeight: 500, letterSpacing: '10px', textTransform: 'uppercase', margin: 0 }}>propertians.com</p>
      </div>

      {/* Header */}
      <div style={{ position: 'relative', zIndex: 10, padding: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ backdropFilter: 'blur(12px)', backgroundColor: 'rgba(255,255,255,0.1)', padding: '30px', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.2)' }}>
          {currentagency?.agencylogo ? (
            <img 
              src={`${AGENCY_LOGOS_URL}${currentagency.agencylogo}`}
              crossOrigin="anonymous"
              style={{ height: '80px', objectFit: 'contain' }}
              alt="logo"
            />
          ) : (
            <h2 style={{ fontSize: '48px', fontWeight: 'bold', letterSpacing: '4px', color: '#d4af37', margin: 0 }}>{currentagency?.agencyname || 'LUXURY ESTATES'}</h2>
          )}
        </div>
        <div style={{ textAlign: 'right' }}>
          <p style={{ fontSize: '24px', fontWeight: 300, letterSpacing: '6px', color: '#d4af37', margin: 0 }}>PREMIUM LISTING</p>
          <div style={{ height: '4px', width: '100px', backgroundColor: '#d4af37', marginLeft: 'auto', marginTop: '10px' }} />
        </div>
      </div>

      {/* Main Content */}
      <div style={{ position: 'relative', zIndex: 10, flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '60px', paddingBottom: '120px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
          <div style={{ display: 'inline-block', alignSelf: 'flex-start', padding: '10px 30px', backgroundColor: '#d4af37', color: 'black', fontWeight: 'bold', fontSize: '24px', borderRadius: '50px' }}>
            FOR {property?.PropertyPurpose?.toUpperCase() || 'SALE'}
          </div>
          
          <h1 style={{ fontSize: '100px', fontWeight: 'bold', lineHeight: 1.1, color: 'white', margin: 0, textShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
            {property?.propertytitle || "Exquisite Urban Living"}
          </h1>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', fontSize: '36px', color: '#d4af37', fontWeight: 300 }}>
            <span>📍</span>
            <span>{property?.SubLocation}, {property?.ProvinceName}</span>
          </div>

          {/* Luxury Divider */}
          <div style={{ width: '100%', height: '2px', background: 'linear-gradient(to right, #d4af37, transparent)', margin: '40px 0' }} />

          {/* Features Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '40px' }}>
            <div style={{ backdropFilter: 'blur(12px)', backgroundColor: 'rgba(255,255,255,0.05)', padding: '30px', borderRadius: '32px', border: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
              <p style={{ color: '#d4af37', fontSize: '48px', marginBottom: '10px', fontWeight: 'bold', margin: 0 }}>{property?.bedrooms || 0}</p>
              <p style={{ color: '#d4af37', fontSize: '20px', textTransform: 'uppercase', letterSpacing: '4px', opacity: 0.7, margin: 0 }}>Beds</p>
            </div>
            <div style={{ backdropFilter: 'blur(12px)', backgroundColor: 'rgba(255,255,255,0.05)', padding: '30px', borderRadius: '32px', border: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
              <p style={{ color: '#d4af37', fontSize: '48px', marginBottom: '10px', fontWeight: 'bold', margin: 0 }}>{property?.bathrooms || 0}</p>
              <p style={{ color: '#d4af37', fontSize: '20px', textTransform: 'uppercase', letterSpacing: '4px', opacity: 0.7, margin: 0 }}>Baths</p>
            </div>
            <div style={{ backdropFilter: 'blur(12px)', backgroundColor: 'rgba(255,255,255,0.05)', padding: '30px', borderRadius: '32px', border: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
              <p style={{ color: '#d4af37', fontSize: '48px', marginBottom: '10px', fontWeight: 'bold', margin: 0 }}>{Math.floor(property?.propertysizesqft || 0)}</p>
              <p style={{ color: '#d4af37', fontSize: '20px', textTransform: 'uppercase', letterSpacing: '4px', opacity: 0.7, margin: 0 }}>Sqft</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Card */}
      <div style={{ position: 'relative', zIndex: 10, padding: '60px', marginBottom: '60px' }}>
        <div style={{ backdropFilter: 'blur(20px)', backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: '64px', padding: '50px', border: '1px solid rgba(212,175,55,0.3)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: '24px', color: '#d4af37', textTransform: 'uppercase', letterSpacing: '4px', marginBottom: '10px', margin: 0 }}>Investment Price</p>
            <p style={{ fontSize: '72px', fontWeight: 'bold', fontStyle: 'italic', color: 'white', margin: 0 }}>PKR {formatPrice(property?.propertyprice)}</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ backgroundColor: '#d4af37', color: 'black', padding: '20px 50px', borderRadius: '50px', fontSize: '24px', fontWeight: 'bold' }}>
              ENQUIRE NOW
            </div>
            <p style={{ marginTop: '20px', fontSize: '24px', fontWeight: 500, color: 'white', margin: 0 }}>{currentagency?.mobileno}</p>
          </div>
        </div>
      </div>

      {/* Hidden Preloaders */}
      <div style={{ display: 'none' }}>
        {imagesArr.map((url, i) => <img key={i} src={url} crossOrigin="anonymous" alt="p" />)}
        {currentagency?.agencylogo && <img src={`${AGENCY_LOGOS_URL}${currentagency.agencylogo}`} crossOrigin="anonymous" alt="l" />}
      </div>
    </div>
  );
};

export default TemplateLuxury;
